import { render } from "./message-revoked.vue?vue&type=template&id=dedd5890&scoped=true&ts=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts"
export * from "./message-revoked.vue?vue&type=script&lang=ts"

import "./message-revoked.vue?vue&type=style&index=0&id=dedd5890&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedd5890"]])

export default __exports__